  // Get toggle switch, table, and label elements
  const unitToggle = document.getElementById('unit-toggle');
  console.log("Unit toggle",unitToggle);
  var unitValue = false;
  console.log("Unit Value",unitValue);
  const vestCM = document.getElementById('vest-cm');
  const vestInch = document.getElementById('vest-inch');
  vestCM.style.display = 'none';
    unitToggle.addEventListener('change', () => {
      var unitValue = unitToggle.checked;
      console.log("Unit Value",unitValue);

     if(unitValue === true){
       console.log("CM");
       vestCM.style.display = 'table';
       vestInch.style.display = 'none';
     }else{
       console.log("Inches");
       vestCM.style.display = 'none';
       vestInch.style.display = 'table';
     }
    });

  // Get elements
  const sizeChartBtn = document.getElementById('size-chart-btn');
  const sizeChartModal = document.getElementById('size-chart-modal');
  const closeSizeChart = document.getElementById('close-size-chart');

  // Open modal
  sizeChartBtn.addEventListener('click', () => {
    sizeChartModal.style.display = 'block';
  });

  // Close modal
  closeSizeChart.addEventListener('click', () => {
    sizeChartModal.style.display = 'none';
  });

  // Close modal when clicking outside the content
  window.addEventListener('click', (event) => {
    if (event.target === sizeChartModal) {
      sizeChartModal.style.display = 'none';
    }
  });